<template>
  <div class="page-error-404">
    <div class="container">
      <div class="jumbotron text-center">
        <div>
          <h3>Ops! Página não encontrada.</h3>
          <h1>404</h1>
        </div>
      </div>
      <div class="text-center">
        <h1><strong class="brand">loca<span>.</span>shop</strong></h1>
        <router-link :to="{name: 'home'}" class="btn btn-info">
          <i class="fa fa-fw fa-home fa-lg"></i> voltar para a Home
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
  export default{
    name: 'Page404'
  }
</script>


// WEBPACK FOOTER //
// Page404.vue?29f4e914